<template>
<main class="main-wrapper flex-grow-1 bg-documentGray">
		<div class="d-flex align-items-center ">
			<div class="t-headline13 t-color-headlineBlack pda-14 font-m flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">
				{{this.$t("212")}}
			</div>
		</div>
		<div class="divider"></div>
		<!-- subtabs -->
		<TopAppBarSurveyListTab></TopAppBarSurveyListTab>
		<NoData v-if="isNoData"></NoData>
		<div class="container pdt-30" v-else>
			<!-- <div class="mgb-24" v-if="campaignData && campaignData.locationValue === null">
				<a v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" target="_blank">
					<img :src="campaignData.image" alt="" class="b-radius4  survey-banner" />
				</a>
			</div>
			<div :class="campaignData && campaignData.image ? 'mgb-24' : ''" v-else>
				<a href="javascript:void(0)" v-if="campaignData && campaignData.image" style="cursor:none" >
					<img :src="campaignData.image" alt="" class="b-radius4  survey-banner" />
				</a>
			</div> -->
			<div class="mdc-card mgb-50 pdt-8 pdb-8 ">
				<div class="pdt-24 pdl-24 pdr-24 d-flex pdb-24 cursor-pointer" 
					v-for="(survey, index) in listData"
					:key="index"
					:class="index+1 == listData.length ? '' : 'my-test-list'"
					>
					<div class="flex-grow-1" @click="moveDetail(survey.id)" @keypress="moveDetail(survey.id)" tabindex="0">
						<div class="t-subtitle3 t-line-h-24 font-m  l-spacing48">
								{{ survey.name }}
						</div>
						<div class="d-flex mgt-8">
							<i class="material-icons t-color-iconInactive mgr-8">groups</i>
							<div class="t-body6 font-r t-color-bodyGrayA l-spacing45 t-line-h-22">
								{{ $t("219", { str: survey.participants }) }}
							</div>
						</div>
						<div class="pdt-4 t-body7 font-r t-color-bodyBlueGray l-spacing45 t-line-h-19" v-if="survey.progression.value === 'SUBMITTED'">
							{{ $t("172") }}
						</div>
						<div class="pdt-4 t-body7 font-r t-color-bodyBlueGray l-spacing45 t-line-h-19" 
								v-else-if="
									survey.progression.value === 'WAITING' ||
									survey.progression.value === 'NONRESPONSE'
								">
							{{ $t("221") }}
						</div>
						<div class="pdt-4 t-body7 font-r t-color-bodyBlueGray l-spacing45 t-line-h-19" v-else>
							<!-- {{ $t("220", { str: $moment(survey.date).format("LL") }) }} -->
							{{ $t("220", { str: $moment(survey.date).format("L") }) }}
						</div>
					</div>
				</div>
			</div>
			<infinite-loading @infinite="fetchData" spinner="spiral">
				<div slot="no-more" class="pdt-16 pdb-16"><!--No more data--></div>
				<div slot="no-results" class="pdt-16 pdb-16"></div>
			</infinite-loading>
		</div>
</main>
</template>

<script>
/**
 * 단독 설문 나의 목록  컴포넌트(independent survey category list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import surveyApi from "@/api/surveyApi.js";
import campaignApi from "@/api/campaignApi.js";
import { MDCRipple } from "@material/ripple";
import NoData from "../../common/NoDataSurveyList.vue";
import InfiniteLoading from "vue-infinite-loading";
import TopAppBarSurveyListTab from "../../TopAppBarSurveyListTab.vue";
export default {
	name: "surveyMy",
	components: {
		NoData,
		InfiniteLoading,
		TopAppBarSurveyListTab
	},

	data() {
		return {
			isNoData: false,
			campaignData: null,
			listData: [],
			currentPage: 1,
			totalPages: 1,
		};
	},

	mounted() {
		// 캠페인 테이터 API 호출(get campaign data)
		campaignApi
			.campaign({ locationType: "INDEPENDENT_SURVEY_LIST" })
			.then((response) => {
				this.campaignData = response.data.data;
			})
			.catch((err) => {});
	},

	updated() {
		const ripples = [].map.call(
			document.querySelectorAll(".ripple-item"),
			function (el) {
				let ripple = new MDCRipple.attachTo(el);
				return ripple;
			}
		);
	},

	methods: {
		// 목록 데이터 호출(get survey list data)
		fetchData($state) {
			let responseData = null;
			let params = this.setParams();

			if (this.totalPages >= this.currentPage) {
				surveyApi.myIndependentSurveyList(params).then((response) => {
					let responseData = response.data.data;
					this.listData = this.listData.concat(responseData.content);
					this.currentPage++;
					this.totalPages = responseData.totalPages;

					if (responseData.content.length) {
						$state.loaded();
					} else {
						$state.complete();
					}
					if (!this.listData.length) {
						this.isNoData = true;
					}
				});
			} else {
				$state.complete();
			}
		},

		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				application: false,
				page: this.currentPage,
				size: 20,
				sort: "id,desc",
			};
			return params;
		},

		// 상세로 이동(move view)
		moveDetail(id) {
			this.$router.push({
				name: "IndependentSurveyTotalView",
				params: { distId: id },
				query: this.$route.query,
			});
		},
	},
};
</script>